import { RootState } from "application/store/reducers/rootReducer";
import { DebitosAutomaticosState } from "application/store/reducers/DebitosAutomaticosReducer";

export const buildCollegePackDto = (
  data: RootState
): DebitosAutomaticosState => {
  const { DebitosAutomaticosState } = data;
  return {
    debit: {
      debitIdentifiers: DebitosAutomaticosState.debit.debitIdentifiers,
      account: DebitosAutomaticosState.debit.account,
      familyIds: DebitosAutomaticosState.debit.familyIds,
      idfPers: DebitosAutomaticosState.debit.idfPers || null,
      hasCardBlack: DebitosAutomaticosState.debit.hasCardBlack
    }
  };
};